import useJurisdiction from '../../../../hooks/useJurisdiction';
import { useGetFundsByPeriodId } from '../../../../services/funds.service';
import { FundsJurisdictions } from '../../Funds/components/Jurisdictions';
import { FormPFFundInformation } from '../../Funds/components/Jurisdictions/FormPFFundInformation';
import { REPORT_TYPES } from '../../../../consts/reportTypes';

export const AddJurisdictionContainer = ({
  isOpen,
  onClose,
  workflowId,
  refetch,
  selectedPeriodId,
  reportType,
  projectName,
  canManageWorkflow = true,
  isLockedPeriod = false,
  // When true, a successful jurisdiction submission redirects the user to
  // the data-extraction page. Used by automation upload-files page where
  // jurisdictions is the last in-page stage before extraction starts.
  isRedirectToExtraction = false
}) => {
  const { data: funds, isLoading: isLoadingFunds } = useGetFundsByPeriodId({
    periodId: selectedPeriodId,
    queryParams: {
      enabled: !!selectedPeriodId && isOpen
    }
  });
  const isFormPFReportType = reportType === REPORT_TYPES.FORM_PF;

  const {
    jurisdictions,
    isLoadingJurisdictionMutate,
    refetchJurisdictions,
    handleJurisdictionSubmit
  } = useJurisdiction({
    onClose,
    refetch,
    periodId: selectedPeriodId,
    projectId: workflowId,
    enabledFetch: isOpen && !!selectedPeriodId,
    isRedirectToExtraction
  });

  const onRefetchJurisdictions = () => {
    refetch();
    refetchJurisdictions();
  };

  if (isFormPFReportType)
    return (
      <FormPFFundInformation
        open={isOpen}
        funds={funds}
        periodId={selectedPeriodId}
        workflowId={workflowId}
        reportType={reportType}
        onClose={onClose}
        isMutating={isLoadingJurisdictionMutate}
        projectName={projectName}
      />
    );

  return (
    <FundsJurisdictions
      open={isOpen}
      funds={funds}
      periodId={selectedPeriodId}
      workflowId={workflowId}
      jurisdictions={jurisdictions}
      isLoadingFunds={isLoadingFunds}
      onClose={onClose}
      reportType={reportType}
      onSubmit={handleJurisdictionSubmit}
      refetchJurisdictions={onRefetchJurisdictions}
      isMutating={isLoadingJurisdictionMutate}
      canManageWorkflow={canManageWorkflow}
      isLockedPeriod={isLockedPeriod}
    />
  );
};
